import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [registrationFee, setRegistrationFee] = useState('3000');
  const [loadingFee, setLoadingFee] = useState(true);

  useEffect(() => {
    const fetchFee = async () => {
      const { data } = await supabase.from('settings').select('value').eq('key', 'registration_fee').maybeSingle();
      if (data?.value) setRegistrationFee(data.value);
      setLoadingFee(false);
    };
    fetchFee();
  }, []);

  const faqs = [
    {
      question: 'Who can participate in Sona Nalam Nova 2026?',
      answer: 'Sona Nalam Nova 2026 is open to undergraduate and postgraduate students from medical, engineering, and science disciplines across India. Teams must consist of 3-4 members from the same college.',
    },
    {
      question: 'What is the registration fee?',
      answer: `The registration fee is ₹${parseInt(registrationFee, 10).toLocaleString('en-IN')} per team. This covers access to all hackathon resources, meals during the event, mentorship sessions, and a participant kit.`,
    },
    {
      question: 'Do we need to bring our own equipment?',
      answer: 'Yes, participants should bring their own laptops and any specific hardware needed for their project. We provide high-speed WiFi, power outlets, and basic prototyping supplies.',
    },
    {
      question: 'Is accommodation provided?',
      answer: 'Basic accommodation is available on campus for outstation teams on a first-come, first-served basis. Details will be shared after registration confirmation.',
    },
    {
      question: 'What if I don\'t have a team?',
      answer: 'All participants must register as a team of 3-4 members. We encourage you to form a team before registering.',
    },
    {
      question: 'Is a faculty mentor mandatory?',
      answer: 'No, having a faculty mentor is optional but encouraged. A mentor can provide valuable guidance during the preparation phase and at the event.',
    },
  ];

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-3">
            Got Questions?
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Frequently Asked <span className="text-primary-600">Questions</span>
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">{faq.question}</span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-colors duration-200 ${
                  openIndex === idx ? 'bg-primary-500' : 'bg-background-200'
                }`}>
                  <i className={`text-xs transition-transform duration-300 ${
                    openIndex === idx ? 'ri-subtract-line text-background-50 dark:text-foreground-950' : 'ri-add-line text-foreground-600'
                  }`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}